import { rankTopics } from "@/mocks/hotTopics";

const trendIcon: Record<string, { icon: string; cls: string; label: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600", label: "热度上升" },
  down: { icon: "ri-arrow-down-line", cls: "text-secondary-600", label: "热度回落" },
  flat: { icon: "ri-arrow-right-line", cls: "text-foreground-400", label: "热度平稳" },
};

export default function HotRank() {
  return (
    <section id="rank" className="bg-background-100/50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              HOT 今日热议榜
            </p>
            <h4 className="flex items-center gap-3 font-serif text-2xl font-black text-foreground-950 md:text-3xl">
              <a href="#rank" className="flex items-center gap-3">
                此刻大家在围观什么
              </a>
            </h4>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-foreground-500">
            按讨论热度排序，数据每 5 分钟刷新一次，反映网友当前最集中的讨论焦点。
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
          <ul className="divide-y divide-background-200">
            {rankTopics.map((t) => {
              const tr = trendIcon[t.trend];
              return (
                <li key={t.rank} className="group-card grid gap-3 px-4 py-4 md:grid-cols-[44px_1fr_auto] md:items-center md:px-6 md:py-3.5">
                  <span
                    className={`hidden font-serif text-2xl font-black leading-none md:block ${
                      t.rank === 1
                        ? "text-primary-600"
                        : t.rank === 2
                          ? "text-accent-600"
                          : t.rank === 3
                            ? "text-secondary-600"
                            : "text-foreground-300"
                    }`}
                  >
                    {String(t.rank).padStart(2, "0")}
                  </span>

                  <div className="flex items-start gap-3 md:items-center">
                    <span className="font-serif text-lg font-black text-foreground-300 md:hidden">
                      {String(t.rank).padStart(2, "0")}
                    </span>
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <p className="text-[15px] font-semibold leading-snug text-foreground-900">
                          {t.title}
                        </p>
                        <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                          {t.zone}
                        </span>
                      </div>
                      <p className="mt-1.5 line-clamp-2 max-w-3xl text-xs leading-relaxed text-foreground-500 md:text-sm">
                        {t.digest}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 md:justify-end">
                    <span className="whitespace-nowrap text-sm font-bold text-foreground-800">
                      {t.heat.toFixed(1)}
                      <span className="ml-0.5 text-xs font-normal text-foreground-400">万热度</span>
                    </span>
                    <span
                      className={`flex h-6 w-6 items-center justify-center rounded-full bg-background-100 text-sm ${tr.cls}`}
                      title={tr.label}
                    >
                      <i className={tr.icon} />
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <p className="mt-4 text-center text-xs text-foreground-400">
          榜单反映网友讨论热度方向，不代表 51嘿料 立场 · 点击话题可前往对应热议分区查看更多讨论
        </p>
      </div>
    </section>
  );
}